import React, { useState, useEffect, useLayoutEffect } from "react";
import style from "./carousel.module.scss"
import diagram from '../../../assets/image/diagram.png'
import report from '../../../assets/image/reports.png'
import variant from '../../../assets/image/variant.png'
import CarouselArrow from '../../../assets/icons/carouselLeftArrow.svg'

let carouselItems = [
    { id: 0, picture: diagram, text: 'سهم بازار را به دست آورید و افزایش فروش خود را حس کنید' },
    { id: 1, picture: report, text: 'با گزارشات پیشرفته، بهترین کالای خود را برای فروش پیدا کنید' },
    { id: 2, picture: variant, text: 'بدون هیچ دردسری تنوع‌های خود را در ربات فعال کنید' }
]

const Carousel = () => {

    const [step, setStep] = useState(0)

    useEffect(() => {
        let changeStep = setInterval(() => {
            let tmp = step
            if ((tmp + 1) < carouselItems.length) {
                tmp++
            } else {
                tmp = 0
            }
            setStep(tmp)
        }, 5000)
        //Clean up can be done like this
        return () => {
            clearInterval(changeStep);
        }
    }, [step]);

    const moveTo = selectedStep => {
        let tmp = selectedStep
        if (tmp > (carouselItems.length - 1)) {
            tmp = 0
        }
        if (tmp < 0) {
            tmp = carouselItems.length - 1
        }
        setStep(tmp)
    }

    return (
        <div className={style.wrapper}>
            <div className={style.itemWrapper}>
                {carouselItems.map((item, index) => {
                    // if (step == item.id) {
                    return <div className={step == item.id ? style.carouselItem : style.carouselItemHidden} key={index}>
                        <div className={style.carouselImageWrapper}>
                            <img src={item.picture} className={style[`carouselImage_${index}`]} />
                        </div>
                        <p className={style.carouselText}>{item.text}</p>
                    </div>
                    // }
                })}
            </div>
            <div className={style.handlerWrapper}>
                <div className={style.arrowWrapper} onClick={() => moveTo(step - 1)}>
                    <div className={style.leftArrow}></div>
                </div>
                {carouselItems.map((dot, index) => <div
                    key={index}
                    className={step == dot.id ? style.fullDot : style.emptyDot}
                    onClick={() => moveTo(index)}
                ></div>
                )}
                <div className={style.arrowWrapper} onClick={() => moveTo(step + 1)}>
                    <div className={style.rightArrow}></div>
                </div>
            </div>
        </div>
    )
}
export default Carousel